module.exports = __webpack_public_path__ + "static/privacypolicy-fd95a067844f5141684d23a1cf6c5760.pdf";